import { getAppType } from "@base/BuildEnvironment";
import { FacadeType } from "@biz/definitions/FacadeDefinitions";
import { PredefinedImageId } from "@biz/items/PredefinedMaterials";

export class BizFacade {
  static getType: () => FacadeType = () => getAppType();
  static getUrl(_id: PredefinedImageId, _type: "image" | "normal"): string | undefined { return undefined }
}